<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="4" offset-lg="7">
        <v-text-field
          v-model="buscaCandidato"
          color="secondary"
          background-color="#f2fff8"
          rounded
          filled
          placeholder="Buscar candidato por nombre o apellido"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col lg="1">
        <v-btn-toggle v-model="ordenAlfabetico" class="card" rounded mandatory>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row v-if="candidatos.length > 0">
      <v-col cols="12" v-if="buscaCandidato.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredCandidatos.length }} resultados encontrados con la búsqueda "{{ buscaCandidato }}"
        </div>
      </v-col>
      <v-expansion-panels flat class="card" focusable hover mandatory>
        <v-expansion-panel v-for="(grupoCandidatos, index) in groupedCandidatos" :key="index">
          <v-expansion-panel-header>
            <div>
              <div class="text-h6 secondary--text font-weight-bold d-inline">
                {{ grupoCandidatos.inicial }}
              </div>
              <div class="text-overline d-inline secondary--text">({{ grupoCandidatos.candidatos.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="candidato in grupoCandidatos.candidatos" :key="candidato.id">
                  <v-card class="card" color="secondary" elevation="8">
                    <v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-avatar rounded color="primary" size="80">
                              <v-icon x-large color="secondary">mdi-account</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" align="center">
                            <div class="text-h6 primary--text font-weight-bold">{{ candidato.apaterno }}</div>
                            <div class="text-subtitle-1 primary--text">
                              {{ candidato.amaterno + ' ' + candidato.nombre + ' ' + candidato.segundoNombre }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                    <v-card-text>
                      <v-sheet height="240" color="transparent"></v-sheet>
                    </v-card-text>
                    <v-card-actions class="secondary darken-1">
                      <v-container>
                        <v-row>
                          <v-col cols="1">
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="error--text mx-2 primary"
                                  elevation="8"
                                  :to="{ name: 'archivarCandidato', params: { id: candidato.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                >
                                  <v-icon>mdi-archive-arrow-down</v-icon>
                                </v-btn>
                              </template>
                              <span>Archivar candidato</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="11" align="right">
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="secondary--text mx-2 primary"
                                  elevation="8"
                                  :to="{
                                    name: 'documentosCandidato',
                                    params: { id: candidato.idPersonal },
                                  }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                >
                                  <v-icon>mdi-file-account</v-icon>
                                </v-btn>
                              </template>
                              <span>Ver expediente</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="secondary--text mx-2 primary"
                                  elevation="8"
                                  :to="{ name: 'validaCandidato', params: { id: candidato.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                >
                                  <v-icon>mdi-check</v-icon></v-btn
                                >
                              </template>
                              <span>Validar candidato</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row v-else>
      <v-col cols="12" align="center">
        <div class="text-h6">No hay candidatos registrados.</div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  data() {
    return {
      buscaCandidato: '',
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('candidato', {
      candidatos: 'getCandidatos',
    }),

    filteredCandidatos: function () {
      return this.candidatos.filter((candidato) => {
        return (
          candidato.nombre.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0 ||
          candidato.segundoNombre.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0 ||
          candidato.apaterno.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0 ||
          candidato.amaterno.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0 ||
          this.getAge(candidato.fechaNacimiento) == this.buscaCandidato
          // (candidato.CatMunicipioRadica && candidato.CatMunicipioRadica.nombre.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0) ||
          // (candidato.CatMunicipioRadica &&
          //     candidato.CatMunicipioRadica.CatEstado.title.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0)
          // (candidato.CatMunicipioNacimiento &&
          //     candidato.CatMunicipioNacimiento.nombre.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0) ||
          // (candidato.CatMunicipioNacimiento &&
          //     candidato.CatMunicipioNacimiento.CatEstado.title.toLowerCase().indexOf(this.buscaCandidato.toLowerCase()) >= 0)
        )
      })
    },

    groupedCandidatos: function () {
      var result = _(this.filteredCandidatos)
        .groupBy((candidato) => candidato.apaterno[0].toUpperCase())
        .map((candidatos, inicial) => ({ inicial, candidatos }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },

  methods: {
    getFullName: function (candidato) {
      return candidato.nombre + ' ' + candidato.segundoNombre + ' ' + candidato.apaterno + ' ' + candidato.amaterno
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Candidatos de Profesionalización */
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}

/* Input de búsqueda */
::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(0, 210, 160, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: #00d2a0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-input__append-inner .v-icon {
  color: rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-input--is-focused .v-input__append-inner .v-icon {
  color: #00d2a0 !important;
}

/* Botón toggle de orden */
::v-deep .v-btn-toggle {
  background: rgba(26, 46, 36, 0.6) !important;
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 12px;
}

::v-deep .v-btn-toggle .v-btn {
  border-radius: 12px !important;
}

::v-deep .v-btn-toggle .v-btn--active {
  background: rgba(0, 210, 160, 0.2) !important;
}

/* Títulos y textos */
.text-h6 {
  color: #e0e0e0 !important;
  font-weight: 700;
}

.secondary--text {
  color: #26de81 !important;
}

.primary--text {
  color: #e0e0e0 !important;
}

/* Expansion Panels */
.card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

::v-deep .v-expansion-panels {
  animation: fadeInUp 0.6s ease-out;
}

::v-deep .v-expansion-panel {
  background: rgba(26, 46, 36, 0.4) !important;
  border: 1px solid rgba(0, 210, 160, 0.15);
  border-radius: 16px !important;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel:hover {
  background: rgba(26, 46, 36, 0.6) !important;
  border-color: rgba(0, 210, 160, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.2);
}

::v-deep .v-expansion-panel-header {
  color: #e0e0e0 !important;
  padding: 20px 24px;
  border-radius: 16px !important;
}

::v-deep .v-expansion-panel-header:hover {
  background: rgba(0, 210, 160, 0.08) !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 16px 24px 24px;
}

/* Cards de candidatos */
::v-deep .v-card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 16px;
  transition: all 0.3s ease;
}

::v-deep .v-card:hover {
  border-color: rgba(0, 210, 160, 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 210, 160, 0.3) !important;
}

::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 16px;
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
}

::v-deep .v-card-text {
  color: #e0e0e0 !important;
}

::v-deep .v-card-actions {
  background: rgba(0, 210, 160, 0.08) !important;
  border-top: 1px solid rgba(0, 210, 160, 0.1);
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(0, 210, 160, 0.3);
  transition: all 0.3s ease;
  background: rgba(0, 210, 160, 0.15) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #00d2a0;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.4);
}

::v-deep .v-avatar .v-icon {
  color: #26de81 !important;
  filter: drop-shadow(0 4px 12px rgba(0, 210, 160, 0.4));
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(0, 210, 160, 0.4) !important;
}

::v-deep .v-btn.primary {
  background: rgba(26, 46, 36, 0.8) !important;
  border: 1px solid rgba(0, 210, 160, 0.3);
}

::v-deep .v-btn.primary:hover {
  background: rgba(26, 46, 36, 0.95) !important;
  border-color: #00d2a0;
}

::v-deep .v-btn.error--text {
  color: #ff5252 !important;
}

::v-deep .v-btn.error--text:hover {
  background: rgba(255, 82, 82, 0.1) !important;
}

::v-deep .v-btn.secondary--text {
  color: #00d2a0 !important;
}

::v-deep .v-btn icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* V-sheet transparente */
::v-deep .v-sheet.transparent {
  background: transparent !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
